<template>
  <v-container fluid class="pt-0">
    <v-row>
      <v-overlay
        :value="
          $store.getters['tenant/activeBranches'].length <= 0
            ? (overlay = true)
            : (overlay = false)
        "
        :opacity="opacity"
      >
        <router-link to="/setting"
          ><h4>{{ $t('cap_required_setup') }}</h4></router-link
        >
      </v-overlay>
      <v-col cols="12">
        <v-row
          v-if="
            ($store.state.account.role === 'owner' ||
              $store.state.account.branchId.length > 1) &&
            $store.getters['tenant/branches'].length > 1
          "
          justify="space-between"
          align="center"
          class="pt-0"
        >
          <v-col cols="12" sm="5">
            <div class="primary--text text-h6 text-md-h5 font-weight-medium">
              {{ $t('btn_txt_orders') }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" class="pt-0">
            <v-select
              v-model="filterBranch"
              :items="branches"
              placeholder="All Branches"
            ></v-select>
          </v-col>
        </v-row>
        <!-- basic analytics -->
        <v-row no-gutters class="mb-2">
          <v-col
            v-for="analytic in analytics"
            :key="analytic.title"
            cols="6"
            md="3"
          >
            <v-card class="ma-1">
              <v-card-text class="ma-0 pb-0">
                {{ analytic.title }}
              </v-card-text>
              <v-card-text :class="`pt-0 ${analytic.color}--text`">
                <div class="text-h6 text-md-h4 font-weight-medium">
                  {{ analytic.data }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- Filter -->
        <v-row no-gutters>
          <v-col cols="12" xs="6" sm="6" md="3">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedDateFormatted"
                  :label="$t('title_txt_start_date')"
                  persistent-hint
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" xs="6" sm="6" md="3">
            <v-text-field
              v-model="search"
              :label="$t('input_txt_search')"
              clearable
              color="primary"
              prepend-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" sm="12" md="6" class="d-flex pt-md-2">
            <v-row no-gutters>
              <v-col cols="12" :sm="showCancel ? '6' : '4'">
                <v-select
                  v-model="sortItem"
                  :label="$t('input_txt_sort')"
                  :items="items"
                  item-text="text"
                  item-value="value"
                  return-object
                  single-line
                  solo
                  flat
                  dense
                  rounded
                  background-color="primary"
                  dark
                ></v-select>
              </v-col>
              <v-col v-if="!showCancel" cols="12" sm="4">
                <v-btn
                  rounded
                  depressed
                  block
                  class="grey lighten-2 d-none d-sm-flex mr-sm-4"
                  @click="showFunnel = !showFunnel"
                  >{{
                    showFunnel
                      ? $t('btn_txt_view_as_table')
                      : $t('btn_txt_view_as_funnel')
                  }}</v-btn
                >
              </v-col>
              <v-col cols="12" :sm="showCancel ? '6' : '4'">
                <v-btn
                  rounded
                  depressed
                  block
                  class="grey lighten-2 mr-sm-4"
                  @click="showCancel = !showCancel"
                  >{{
                    showCancel
                      ? $t('btn_txt_view_active_order')
                      : $t('btn_txt_view_cancel_order')
                  }}</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- Process Card List -->
        <v-row
          v-if="$vuetify.breakpoint.smAndUp && showFunnel && !showCancel"
          class="justify-center"
          no-gutters
        >
          <v-col
            v-for="dragListItem in draggableList"
            :key="dragListItem.title"
            cols="12"
            sm="4"
          >
            <v-card class="grey lighten-3 mr-2">
              <v-card class="mb-2" max-height="4em">
                <v-card-title>
                  <v-icon :color="dragListItem.iconColor" class="mx-2">
                    {{ dragListItem.icon }}
                  </v-icon>
                  <span style="font-size: calc(0.8vw + 0.8vh + 0.5vmin)">
                    {{ dragListItem.title }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn rounded small color="grey lighten-1" dark>
                    <span>{{ dragListItem.count }}</span>
                    <v-icon right medium>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
              <v-list
                height="360"
                class="overflow-y-auto grey lighten-3 group-item"
              >
                <draggable
                  :id="dragListItem.id"
                  :list="dragListItem.list"
                  group="process"
                  :move="checkMove"
                  animation="300"
                  @add="moveOrder($event, dragListItem.status)"
                >
                  <v-card
                    v-for="order in dragListItem.list"
                    :key="order.documentId"
                    :color="
                      order.delivery.status !== 'delivering' ? '' : 'secondary1'
                    "
                    class="ma-2 px-6 py-3 body-2 list-group-item"
                    :data-id="order.documentId"
                    :to="{
                      name: 'CassOrderDetail',
                      params: { order_id: order.documentId }
                    }"
                  >
                    <v-row>
                      <span class="primary--text">{{
                        order.customer.phone
                      }}</span>
                      <v-spacer></v-spacer>
                      <span>$ {{ order.total | numberFormat }}</span>
                    </v-row>
                    <v-row>
                      <span color="blue lighten-4">{{
                        order.timestamp.toDate() | dateFormat
                      }}</span>
                      <v-spacer></v-spacer>
                      <span> {{ order.delivery.name | nameFormat }} </span>
                    </v-row>
                    <v-row v-if="order.delivery.fee">
                      <span>
                        {{ $t('cap_delivery_fee') }} :{{
                          order.delivery.fee | nameFormat
                        }}
                        $</span
                      >
                    </v-row>
                  </v-card>
                </draggable>
              </v-list>
              <div class="body-2 d-flex flex-row ml-4 my-2">
                {{ $t('cap_order_footer_see_more') }}
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!-- Process Data Table -->
        <v-row
          v-if="$vuetify.breakpoint.xsOnly || !showFunnel || showCancel"
          no-gutter
          class="d-flex justify-center"
        >
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="orderTableItem"
              :items-per-page="5"
              style="cursor: pointer"
              @click:row="moreDetail($event.documentId)"
            >
              <template v-slot:item.icon="{ item }">
                <v-icon class="mr-2" :color="item.iconColor">
                  {{ item.icon }}
                </v-icon>
              </template>
              <template v-slot:item.button="{}">
                <v-icon v-if="$vuetify.breakpoint.mdAndUp" size="40">
                  mdi-hand-pointing-up
                </v-icon>
              </template>
              <template v-slot:no-data>
                <span class="primary--text">{{
                  $t('cap_txt_data_table_empty')
                }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- Dialog When Drag Order -->
        <CassOrderProcessDialog
          :document-id="documentId"
          :dialog-process="dialog.dialogProcess"
          :locale="locale"
          @changeDialog="updateDialog($event)"
        ></CassOrderProcessDialog>
        <CassOrderDoneDialog
          :document-id="documentId"
          :dialog-done="dialog.dialogDone"
          @changeDialog="updateDialog($event)"
        ></CassOrderDoneDialog>
      </v-col>
    </v-row>
    <!-- Individual Order Detail -->
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import CassOrderProcessDialog from '../components/dialogs/CassOrderProcessDialog'
import CassOrderDoneDialog from '../components/dialogs/CassOrderDoneDialog'

export default {
  name: 'ProcessCardList',
  components: {
    draggable,
    CassOrderProcessDialog,
    CassOrderDoneDialog
  },
  filters: {
    dateFormat(data) {
      let month = data.getMonth() + 1
      let date = data.getDate()
      month = month > 9 ? month : '0' + month
      date = date > 9 ? date : '0' + date
      return `${month}/${date}`
    },
    nameFormat(data) {
      return data || '-'
    },
    numberFormat(data) {
      return (Math.round(data * 100) / 100).toFixed(2)
    }
  },
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  data() {
    return {
      overlay: false,
      opacity: 1,
      documentId: null,
      dialog: {
        dialogProcess: false,
        dialogDone: false
      },
      menu: false,
      sampleDate: this.$store.state.order.startDate.timestamp || '2020-06-01',
      search: '',
      sortItem: { text: this.$t('btn_txt_sort_by_date'), value: 'timestamp' },
      showFunnel: true,
      showCancel: false,
      filterBranch: 'All Branches'
    }
  },
  computed: {
    branches() {
      let branch = []
      if (this.$store.state.account.role === 'owner') {
        branch = JSON.parse(
          JSON.stringify(this.$store.getters['tenant/branches'])
        )
      } else {
        branch = JSON.parse(JSON.stringify(this.$store.state.account.branchId))
      }
      branch.unshift('All Branches')
      return branch
    },
    headers() {
      return [
        {
          text: this.$t('cap_order_header_status'),
          value: 'icon',
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('cap_order_header_id'),
          value: 'documentId',
          sortable: false
        },
        {
          text: this.$t('cap_order_header_date'),
          value: 'timestamp',
          sortable: false
        },
        {
          text: this.$t('cap_order_header_contact'),
          value: 'customer.phone',
          sortable: false
        },
        {
          text: this.$t('cap_order_header_payment'),
          value: 'payment.method',
          sortable: false
        },
        {
          text: this.$t('cap_order_header_amount'),
          value: 'total',
          sortable: false
        },
        {
          text: this.$t('cap_order_header_delivery'),
          value: 'delivery.name',
          sortable: false
        },
        { text: '', value: 'button', sortable: false }
      ]
    },
    analytics() {
      return [
        {
          title: this.$t('title_txt_total_ord_month'),
          data: this.$store.getters['order/thisMonthOrder'],
          color: 'primary'
        },
        {
          title: this.$t('title_txt_total_usr_month'),
          data: this.$store.state.tenant.totalUsers,
          color: 'primary'
        },
        {
          title: this.$t('title_txt_total_ord_today'),
          data: this.$store.getters['order/todayOrder'].length,
          color: 'primary'
        },
        {
          title: this.$t('title_txt_unprocc_ord'),
          data: this.$store.getters['order/newOrder'].length,
          color: 'error'
        }
      ]
    },
    items() {
      return [
        { text: this.$t('btn_txt_sort_by_date'), value: 'timestamp' },
        { text: this.$t('btn_txt_sort_by_id'), value: 'documentId' }
      ]
    },
    date: {
      get() {
        return this.dateFullFormat(new Date(this.sampleDate))
      },
      set(value) {
        this.sampleDate = value
      }
    },
    computedDateFormatted() {
      return this.formatDate(this.date)
    },
    orderList() {
      const searchTerm = this.search ? this.search.toLowerCase() : ''
      return this.$store.getters['order/orderAfterFilter']
        .filter((order) => {
          const dateFrom = new Date(this.date)
          dateFrom.setHours(0)
          const phoneFormat = order.customer.phone.split(' ').join('')
          if (order.delivery.name && order.delivery.status) {
            return (
              (phoneFormat.includes(searchTerm) ||
                order.total.toString().toLowerCase().includes(searchTerm) ||
                order.delivery.name.toLowerCase().includes(searchTerm) ||
                order.delivery.status.toLowerCase().includes(searchTerm)) &&
              order.timestamp.toDate() >= dateFrom
            )
          } else if (order.delivery.status) {
            return (
              (phoneFormat.includes(searchTerm) ||
                order.total.toString().toLowerCase().includes(searchTerm) ||
                order.delivery.status.toLowerCase().includes(searchTerm)) &&
              order.timestamp.toDate() >= dateFrom
            )
          } else {
            return (
              (phoneFormat.includes(searchTerm) ||
                order.total.toString().toLowerCase().includes(searchTerm)) &&
              order.timestamp.toDate() >= dateFrom
            )
          }
        })
        .sort(this.compareValues(this.sortItem.value))
    },
    draggableList() {
      return [
        {
          icon: 'mdi-bell-ring-outline',
          iconColor: 'red',
          title: this.$t('cap_order_header_new_order'),
          count: this.newOrderList.length,
          id: 'order-group',
          list: this.newOrderList,
          status: 'newOrder',
          seeMore: this.$t('cap_order_footer_see_more')
        },
        {
          icon: 'mdi-truck-delivery-outline',
          iconColor: 'primary',
          title: this.$t('cap_order_header_processing'),
          count: this.processingList.length,
          id: 'processing-group',
          list: this.processingList,
          status: 'processing',
          seeMore: this.$t('cap_order_footer_see_more')
        },
        {
          icon: 'mdi-checkbox-outline',

          iconColor: 'teal accent-2',
          title: this.$t('cap_order_header_done'),
          count: this.doneList.length,
          id: 'done-group',
          list: this.doneList,
          status: 'done',
          seeMore: this.$t('cap_order_footer_see_more')
        }
      ]
    },
    newOrderList() {
      return this.orderList.filter((order) => order.status === 'newOrder')
    },
    processingList() {
      return this.orderList.filter((order) => order.status === 'processing')
    },
    doneList() {
      return this.orderList.filter(
        (order) => order.status === 'done' && order.payment.paid
      )
    },
    orderTableItem() {
      const orderItem = []
      let icon = ''
      let iconColor = ''
      this.orderList.forEach((order) => {
        const orderCopy = { ...order }
        if (orderCopy.status === 'newOrder') {
          icon = 'mdi-bell-ring-outline'
          iconColor = 'red'
        } else if (orderCopy.status === 'processing') {
          icon = 'mdi-truck-delivery-outline'
          iconColor = 'primary'
        } else if (orderCopy.status === 'done') {
          icon = 'mdi-checkbox-outline'
          iconColor = 'teal accent-2'
        } else {
          icon = 'mdi-close-box-outline'
          iconColor = 'red'
        }
        orderCopy.icon = icon
        orderCopy.iconColor = iconColor
        orderCopy.timestamp = this.dateFormat(order.timestamp.toDate())
        orderCopy.total = '$ ' + this.numberFormat(order.total)
        orderCopy.delivery.name = this.nameFormat(order.delivery.name)
        // orderCopy.payment.method = `${this.nameFormat(order.payment.method)} (${this.toTitleCase(order.delivery.mode)})`
        orderItem.push(orderCopy)
      })
      if (this.showCancel) {
        return orderItem.filter((order) => order.status === 'cancel')
      } else {
        return orderItem.filter((order) => order.status !== 'cancel')
      }
    }
  },
  watch: {
    filterBranch(v) {
      const branch = v === 'All Branches' ? '' : v.toLowerCase()
      this.$store.commit('order/filterBranch', branch)
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      })
      const [
        { value: month },
        ,
        { value: day },
        ,
        { value: year }
      ] = dateTimeFormat.formatToParts(new Date(date))
      return `${month} ${day}, ${year}`
    },
    moveOrder(event, status) {
      this.documentId = event.item.getAttribute('data-id')
      if (
        event.from.id === 'order-group' &&
        event.to.id === 'processing-group'
      ) {
        this.dialog.dialogProcess = true
      } else if (
        event.from.id === 'processing-group' &&
        event.to.id === 'done-group'
      ) {
        this.dialog.dialogDone = true
      }
      this.changeLocalStatus(event, status)
    },
    changeLocalStatus(event, status) {
      const documentId = this.documentId
      const payload = { documentId, status }
      this.$store.dispatch('order/changeLocalStatus', payload)
    },
    checkMove(event) {
      if (
        event.from.id === 'order-group' &&
        event.to.id === 'processing-group'
      ) {
        return true
      }
      if (
        event.from.id === 'processing-group' &&
        event.to.id === 'done-group'
      ) {
        return true
      }
      return false
    },
    updateDialog(dialog) {
      this.dialog = dialog
    },
    compareValues(key, order = 'asc') {
      return function innerSort(a, b) {
        const keys = key.split('.')
        let i = 0
        while (i < keys.length) {
          a = a[keys[i]]
          b = b[keys[i]]
          i++
        }
        const varA = typeof a === 'string' ? a.toUpperCase() : a
        const varB = typeof b === 'string' ? b.toUpperCase() : b

        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return order === 'desc' ? comparison * -1 : comparison
      }
    },
    moreDetail(documentId) {
      // console.log(this.date)
      this.$router.push({
        name: 'CassOrderDetail',
        params: { order_id: documentId }
      })
    },
    dateFormat(data) {
      let month = data.getMonth() + 1
      let date = data.getDate()
      month = month > 9 ? month + 1 : '0' + month
      date = date > 9 ? date : '0' + date
      return `${month}/${date}`
    },
    dateFullFormat(data) {
      let month = data.getMonth() + 1
      let date = data.getDate()
      const year = data.getFullYear()
      month = month > 9 ? month : '0' + month
      date = date > 9 ? date : '0' + date
      return `${year}-${month}-${date}`
    },
    nameFormat(data) {
      return data || '-'
    },
    numberFormat(data) {
      return (Math.round(data * 100) / 100).toFixed(2)
    },
    toTitleCase(str) {
      return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase()
    }
  }
}
</script>

<style scoped>
.list-group-item {
  cursor: pointer;
}
/* width */
.group-item::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.group-item::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.group-item::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.group-item::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
